import {mapGetters, mapActions} from 'vuex';
import {TimelineMax, TweenMax, Back} from 'gsap';
const analyticsEvent = require('../../../../viscomjs/analytics/analyticsEvent');
const elementsTracking = require('../../../../viscomjs/analytics/elementsTracking');
const ShareButtons = require('../../../../viscomjs/ui/ShareButtons');
const SplitText = require('../../../../viscomjs/utils/SplitText');
const Utils = require('../../../../viscomjs/utils/utils');
const share = require('../../share');
const meta = require('../../meta');

export default {
    name: 'results',
    props: {
        data: Object,
        restartDestination: String
    },
    computed: {
        visibility() {
            return this.entered;
        },
        ...mapGetters('quiz', ['result', 'totalScore']),
        id() {
            return this.result ? this.result.id : '';
        },
        title() {
            return this.result ? this.result.title : '';
        },
        label() {
            return this.result ? this.result.eventLabel : '';
        },
        content() {
            return this.result ? this.result.text : [];
        }
    },
    data() {
        return {
            entered: false,
            transitionName: 'in',
            ttlVisible: '',
            headerVisible: '',
            contentVisible: '',
            shareVisible: ''
        };
    },
    mounted() {
        this.prepareTitle();
        this.entered = true;

        this.startAnalytics();
        this.startShare();
    },
    beforeDestroy() {
        this.destroyAnalytics();
        this.destroyShare();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.transitionName = 'in';
            vm.entered = true;
            analyticsEvent('Quiz', 'complete', 'Score: ' + vm.totalScore);
            analyticsEvent('Quiz', 'complete', 'Result: ' + vm.totalScore);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.transitionName = 'out';
        this.entered = false;
        this.hide();
        TweenMax.delayedCall(0.5, () => {
            this.reset();
            next();
        });
    },
    watch: {
        visibility(to) {
            if (to) this.show();
            else this.hide();
        }
    },
    methods: {
        ...mapActions('quiz', ['reset']),
        show() {
            const tl = new TimelineMax({
                delay: 0.4
            });
            tl.addLabel('st');
            tl.call(this.setHeaderVisible, [], this, 'st+=' + 0.15);
            tl.call(this.setTtlVisible, [], this, 'st+=' + 0.25);
            tl.call(this.setContentVisible, [], this, 'st+=' + 0.5);
            tl.call(this.setShareVisible, [], this, 'st+=' + 0.75);
        },
        hide() {
            const tl = new TimelineMax();
            tl.addLabel('st');
            tl.call(this.setShareInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.setContentInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.setTtlInvisible, [], this, 'st+=' + 0.15);
            tl.call(this.setHeaderInvisible, [], this, 'st+=' + 0.15);
        },
        setContentVisible() {
            this.contentVisible = 'active';
        },
        setTtlVisible() {
            this.ttlVisible = 'active';
        },
        setHeaderVisible() {
            this.headerVisible = 'active';
        },
        setShareVisible() {
            this.shareVisible = 'active';

            TweenMax.staggerFrom(
                '.results__share button',
                0.5,
                {
                    opacity: 0,
                    yPercent: 100,
                    cycle: {
                        ease: i => {
                            return Back.easeOut.config(i);
                        }
                    }
                },
                0.1
            );
        },
        setTtlInvisible() {
            this.ttlVisible = '';
        },
        setHeaderInvisible() {
            this.headerVisible = '';
        },
        setContentInvisible() {
            this.contentVisible = '';
        },
        setShareInvisible() {
            this.shareVisible = '';
        },
        restart() {
            // Reset and go to the beginning?
            this.$router.push(this.restartDestination);
        },
        startAnalytics() {
            elementsTracking.init(this.$el);
        },
        startShare() {
            let obj = share[this.id];
            obj = Utils.extend(obj, {
                url: `${meta.url}/share.php?type=${this.id}`
            });
            this.__share = ShareButtons(meta, [...this.$el.querySelectorAll('.share__item')], obj);
        },
        destroyAnalytics() {
            elementsTracking.destroy(this.$el);
        },
        destroyShare() {
            if (this.__share) this.__share.destroy();
        },
        prepareTitle() {
            SplitText.wrapSymbols([this.$el.querySelector('.results__ttl')], {
                cssProperty: 'transition',
                // reverse: true,
                factor: 1.15,
                durationRatio: 0.3,
                durationMax: 1.15,
                durationMin: 0.95,
                nestingNum: 2,
                timingNestingLevel: 1
            });
        }
    },
    template: require('../../../../../../components/templates/results.pug')
};
